import React, { Component } from 'react';

function MetricItem(props) {
  return <div className="column">
          <div className="content">
            <div className="column has-text-black has-text-centered">
              <p className="is-size-1"><i className={props.icon}></i></p>
            </div>
            <div className="column has-text-black has-text-centered">
              <nav className="level">
                <div className="level-item has-text-centered">
                  <div>
                    <p className="heading has-text-weight-bold is-size-6 is-size-7-mobile">{props.heading}</p>
                    <p className="title has-text-weight-bold has-text-black is-size-3 is-size-4-mobile">{props.description}</p>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
}

function ButtonItem() {
  return <div className="column has-text-centered">
          <a href="#/all_projects" name="about" className="button is-black is-outlined">
              VIEW PROJECTS
          </a>
        </div>
}

class Projects extends Component {
  constructor() {
    super();
  }

  render() {

    const metrics = {
      headings: {
        'personal': 'PERSONAL PROJECTS',
        'hackathons': 'HACKATHONS',
        'course-projects': 'COURSE PROJECTS',
        'experience': 'YEARS OF EXPERIENCE',
        'coding-questions': 100
      },
      numbers: {
        'personal': 3,
        'hackathons': 3,
        'course-projects': 10,
        'experience': '5+',
        'coding-questions': 100
      },
      icons: {
        'personal': 'fas fa-laptop-code',
        'hackathons': 'fas fa-atom',
        'course-projects': 'fas fa-pencil-ruler',
        'experience': 'fas fa-briefcase',
        'coding-questions': 'fas fa-code'
      }
    }

    return (
      <div id="projects" className="hero">

        <div className="container padding-two-top padding-two-bottom is-hidden-touch">
          <div className="columns is-mobile">
            <MetricItem heading={metrics['headings']['personal']} description={metrics['numbers']['personal']} icon={metrics['icons']['personal']}/>
            <MetricItem heading={metrics['headings']['hackathons']} description={metrics['numbers']['hackathons']} icon={metrics['icons']['hackathons']}/>
            <MetricItem heading={metrics['headings']['course-projects']} description={metrics['numbers']['course-projects']} icon={metrics['icons']['course-projects']}/>
            <MetricItem heading={metrics['headings']['experience']} description={metrics['numbers']['experience']} icon={metrics['icons']['experience']}/>
          </div>
          <ButtonItem/>
        </div>
          
        <div className="padding-two-top padding-two-bottom is-hidden-desktop">
          <div className="columns is-mobile">
            <MetricItem heading={metrics['headings']['personal']} description={metrics['numbers']['personal']} icon={metrics['icons']['personal']}/>
            <MetricItem heading={metrics['headings']['hackathons']} description={metrics['numbers']['hackathons']} icon={metrics['icons']['hackathons']}/>
          </div>

          <div className="columns is-mobile">
            <MetricItem heading={metrics['headings']['course-projects']} description={metrics['numbers']['course-projects']} icon={metrics['icons']['course-projects']}/>
            <MetricItem heading={metrics['headings']['experience']} description={metrics['numbers']['experience']} icon={metrics['icons']['experience']}/>
          </div>
          <ButtonItem/>
        </div>

      </div>
    );
  }
}

export default Projects;